'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Type2 = require('./Type');

var _Type3 = _interopRequireDefault(_Type2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

/* eslint-disable */

var StringType = function (_Type) {
  _inherits(StringType, _Type);

  StringType.from = function from(s) {
    return '' + s;
  };

  function StringType() {
    var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Please enter a valid string';

    _classCallCheck(this, StringType);

    var _this = _possibleConstructorReturn(this, _Type.call(this, 'string'));

    _Type.prototype.pushCheck.call(_this, function (v) {
      return typeof v === 'string';
    }, errorMessage);
    return _this;
  }

  StringType.prototype.containsLetter = function containsLetter(errorMessage) {
    _Type.prototype.pushCheck.call(this, function (v) {
      return (/[a-zA-Z]/.test(v)
      );
    }, errorMessage);
    return this;
  };

  StringType.prototype.containsUppercaseLetter = function containsUppercaseLetter(errorMessage) {
    _Type.prototype.pushCheck.call(this, function (v) {
      return (/[A-Z]/.test(v)
      );
    }, errorMessage);
    return this;
  };

  StringType.prototype.containsLowercaseLetter = function containsLowercaseLetter(errorMessage) {
    _Type.prototype.pushCheck.call(this, function (v) {
      return (/[a-z]/.test(v)
      );
    }, errorMessage);
    return this;
  };

  StringType.prototype.containsLetterOnly = function containsLetterOnly(errorMessage) {
    _Type.prototype.pushCheck.call(this, function (v) {
      return (/^[a-zA-Z]+$/.test(v)
      );
    }, errorMessage);
    return this;
  };

  StringType.prototype.containsNumber = function containsNumber(errorMessage) {
    _Type.prototype.pushCheck.call(this, function (v) {
      return (/[0-9]/.test(v)
      );
    }, errorMessage);
    return this;
  };

  StringType.prototype.isOneOf = function isOneOf(strArr, errorMessage) {
    _Type.prototype.pushCheck.call(this, function (v) {
      return ~strArr.indexOf(v);
    }, errorMessage);
    return this;
  };

  StringType.prototype.isEmail = function isEmail(errorMessage) {
    //http://emailregex.com/
    var regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    _Type.prototype.pushCheck.call(this, function (v) {
      return regexp.test(v);
    }, errorMessage);
    return this;
  };

  StringType.prototype.isURL = function isURL(errorMessage) {
    var regexp = new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i');
    _Type.prototype.pushCheck.call(this, function (v) {
      return regexp.test(v);
    }, errorMessage);
    return this;
  };

  StringType.prototype.isHex = function isHex(errorMessage) {
    var regexp = /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i;
    _Type.prototype.pushCheck.call(this, function (v) {
      return regexp.test(v);
    }, errorMessage);
    return this;
  };

  StringType.prototype.pattern = function pattern(regexp, errorMessage) {
    _Type.prototype.pushCheck.call(this, function (value) {
      return regexp.test(value);
    }, errorMessage);
    return this;
  };

  StringType.prototype.rangeLength = function rangeLength(minLength, maxLength, errorMessage) {
    _Type.prototype.pushCheck.call(this, function (value) {
      return value.length >= minLength && value.length <= maxLength;
    }, errorMessage);
    return this;
  };

  StringType.prototype.minLength = function minLength(_minLength, errorMessage) {
    _Type.prototype.pushCheck.call(this, function (value) {
      return [].concat(_toConsumableArray(value)).length >= _minLength;
    }, errorMessage);
    return this;
  };

  StringType.prototype.maxLength = function maxLength(_maxLength, errorMessage) {
    _Type.prototype.pushCheck.call(this, function (value) {
      return [].concat(_toConsumableArray(value)).length <= _maxLength;
    }, errorMessage);
    return this;
  };

  return StringType;
}(_Type3.default);

exports.default = function (errorMessage) {
  return new StringType(errorMessage);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/schema-typed/lib/StringType.js
// module id = 570
// module chunks = 0